/* src/modules/create_tutor/api.js */

import gql from 'graphql-tag';

export const ADD_TUTORS_MUTATION = gql`
  mutation addTutors($addTutorsInput: [AddTutorsInput]!, $password: String!, $organization: ID!, $university: ID!) {
    addTutors(input: $addTutorsInput, password: $password, _organization: $organization, _university: $university) {
      _id
      user {
        _id
        first
        last
        email
      }
      courses {
        course {
          _id
          subject
          number
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modules/create_tutor/api.js